import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { BRAND } from "@/constants/compliance";

export default function PrivacyPage() {
  return (
    <LegalLayout
      testId="privacy-page"
      eyebrow="Legal"
      title="Privacy Policy"
      updated="July 1, 2026"
    >
      <LegalSection num="01" title="Information we collect" testId="privacy-section-collect">
        <p>
          When you opt in to {BRAND.name} — by texting {BRAND.keyword} to{" "}
          {BRAND.number} or through our website form — we collect your mobile
          phone number, your name (if provided via the website), your reminder
          preferences, and your opt-in consent record (timestamp and method).
        </p>
      </LegalSection>

      <LegalSection num="02" title="How we use your information" testId="privacy-section-use">
        <p>
          We use your information solely to operate the messaging program:
          sending the automated task reminders and schedule updates you
          requested, confirming your opt-in, processing HELP and STOP
          requests, and maintaining proof of consent as required by carriers.
        </p>
      </LegalSection>

      <LegalSection num="03" title="Mobile information sharing" testId="privacy-section-sharing">
        <p>
          No mobile information will be shared with third parties or
          affiliates for marketing or promotional purposes. All the above
          categories exclude text messaging originator opt-in data and
          consent; this information will not be shared with any third
          parties.
        </p>
        <p>
          We do not sell, rent, or trade your phone number or personal
          information.
        </p>
      </LegalSection>

      <LegalSection num="04" title="Data security" testId="privacy-section-security">
        <p>
          We store your contact details and consent records in secured
          systems with access limited to what is needed to operate the
          service. While no system is perfectly secure, we apply reasonable
          administrative and technical safeguards.
        </p>
      </LegalSection>

      <LegalSection num="05" title="Your rights & opt-out" testId="privacy-section-rights">
        <p>
          You may withdraw consent at any time by texting{" "}
          <span className="font-semibold text-[#1E2022]">STOP</span> to{" "}
          {BRAND.number}. You may also request access to, correction of, or
          deletion of your personal data by emailing {BRAND.email}.
        </p>
      </LegalSection>

      <LegalSection num="06" title="Data retention" testId="privacy-section-retention">
        <p>
          We retain your information for as long as your subscription is
          active, plus a limited period afterward to honor opt-out requests
          and demonstrate carrier compliance. Opted-out numbers are
          suppressed from all future messaging.
        </p>
      </LegalSection>

      <LegalSection num="07" title="Changes to this policy" testId="privacy-section-changes">
        <p>
          We may update this Privacy Policy from time to time. The current
          version is always available at {BRAND.domain}/privacy, with the
          last-updated date shown at the top.
        </p>
      </LegalSection>

      <LegalSection num="08" title="Contact us" testId="privacy-section-contact">
        <p>
          Questions about this policy or your data? Email {BRAND.email} or
          text HELP to {BRAND.number}.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
